const _scopedState = (state) => state.entities.pinnedContainer;

const pinnedContainers = (state) => _scopedState(state).pinnedContainers;
const isLoading = (state) => _scopedState(state).isLoading;

export default {
  pinnedContainers,
  isLoading,
};
